import { createSelector } from "reselect";
import { getPractice } from "utils/practiceStorage";
import { initialState } from "./reducer";

/**
 * Direct selector to the clinicPage state domain
 */

const selectPracticePageDomain = state =>
  state.get("globalPracticePage", initialState);

/**
 * Other specific selectors
 */
export const makeSelectPractices = () =>
  createSelector(selectPracticePageDomain, substate =>
    substate.get("practices").toJS(),
  );

export const makeSelectPractice = () =>
  createSelector(selectPracticePageDomain, () => getPractice());

/**
 * Default selector used by PracticePage
 */

const makeSelectPracticePage = () =>
  createSelector(selectPracticePageDomain, substate => substate.toJS());

export default makeSelectPracticePage;
export { selectPracticePageDomain };
